export type PaymentProps = {
  file?: File,
  mode: string,
  coupon?: string,
};

export type AgreementProps = {
  content: ?string,
  name: ?string,
  file: ?File,
  token: ?string,
};

export const PaymentTypes = {
  TRANSFER: 'TRANSFER',
  CREDIT: 'CREDIT',
  PAYPHONE: 'PAYPHONE',
  CASH: 'CASH',
  CREDIT_CARD: 'CREDIT_CARD',
  DEUNA: 'DEUNA',
};
